/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/
import { Service } from '@hems/service/src/api/Service';
import { apiWrapper } from '@hems/service/src/util/apiHelper';
export default class NoticeService extends Service {
    constructor(axios) {
        super(axios);
    }
    /** 공지사항 상세 조회 */
    getNoticeInfo = async (noticeId) => {
        const { data } = await this.get(apiWrapper.managerApi('/managements/notice'), { noticeId });
        return data;
    };
    /** 공지사항 목록 조회 */
    getNoticeList = async (params) => {
        const { data } = await this.get(apiWrapper.managerApi('/managements/notice/list'), params);
        return data;
    };
    /** 공지사항 생성 */
    createNotice = async (noticeInfo) => {
        const { data } = await this.post(apiWrapper.managerApi('/managements/notice'), noticeInfo);
        return data;
    };
    /** 공지사항 삭제 */
    deleteNotice = async (noticeId) => {
        const { data } = await this.delete(apiWrapper.managerApi('/managements/notice/delete'), undefined, { data: { noticeId } });
        return data;
    };
    /** 공지사항 수정 */
    updateNotice = async (noticeInfo) => {
        const { data } = await this.put(apiWrapper.managerApi('/managements/notice'), noticeInfo);
        return data;
    };
}
